import { Avatar, AvatarColor, AvatarSize } from '@vizit/atoms';
import { getEntityInitials } from '@vizit/utils';

const AVATAR_COLORS = [AvatarColor.Cyan, AvatarColor.Salmon, AvatarColor.Blue, AvatarColor.Black];

const colorFor = (id: string) =>
  AVATAR_COLORS[[...id].reduce((hash, char) => hash + char.charCodeAt(0), 0) % AVATAR_COLORS.length];

interface OpportunityBrandAvatarProps {
  id: string;
  name: string;
  size?: AvatarSize;
}

function OpportunityBrandAvatar(props: OpportunityBrandAvatarProps) {
  const { id, name, size = AvatarSize.Small } = props;

  return (
    <Avatar color={colorFor(id)} size={size}>
      {getEntityInitials(name)}
    </Avatar>
  );
}

export { OpportunityBrandAvatar };
